import { Box } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { ReactNode } from 'react';

type LevelTwoAnimationWrapperProps = {
    showLevelThree: boolean;
    levelTwoChildren: ReactNode;
    levelThreeChildren: ReactNode;
};

export function LevelTwoAnimationWrapper(props: LevelTwoAnimationWrapperProps) {
    const { showLevelThree, levelTwoChildren, levelThreeChildren } = props;
    const showLevelTwo = !showLevelThree;

    return (
        <motion.div
            initial={{ height: 'fit-content' }}
            animate={{ height: showLevelThree ? 300 : 'fit-content' }}
            exit={{ height: 'fit-content' }}
            style={{
                width: '100%',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <AnimatePresence>
                {showLevelThree && (
                    <Box sx={{
                        '& > div': {
                            position: 'absolute',
                            top: 0,
                            display: 'flex',
                            width: '100%',
                        },
                    }}
                    >
                        <motion.div
                            initial={{ x: '100%', height: 200 }}
                            animate={{ x: 0, height: 380 }}
                            exit={{ x: '100%', height: 200 }}
                            transition={{ duration: 0.4 }}
                        >
                            {levelThreeChildren}
                        </motion.div>
                    </Box>
                )}
            </AnimatePresence>
            <AnimatePresence>
                {showLevelTwo && (
                    <motion.div
                        initial={{ x: '-100%' }}
                        animate={{ x: 0 }}
                        exit={{ x: '-100%' }}
                        transition={{ duration: 0.4 }}
                    >
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, 180px)',
                            justifyContent: 'space-evenly',
                            rowGap: 2,
                            paddingY: 4,
                            width: '100%',
                        }}
                        >
                            {levelTwoChildren}
                        </Box>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
}
